import axios from 'axios';
import Debug from "debug";

const clientIp = async () => {
	const url = '/wp-ajax?action=cig_get_client_ip';

	try {
		const response = await axios.get(url);

		return (response.status === 200) ? response.data : null;
	}
	catch (err) {
		Debug(`cig:error:sage:function:clientIp`)(`clientIp Error: %s %o`, err.message, err);
		return false;
	}
};

export default clientIp;
